import { Component, EventEmitter, OnDestroy, OnInit, Output, inject, DestroyRef, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Subscription } from 'rxjs';
import { AppService } from '../../app.service';
import { UserAdminService } from '../user-admin.service';
import { GtwSnackbarService } from '../../shared/_services/gtw-snackbar.service';
import { GlobalService } from '../../global/services/global.service';
import { WorkspaceService } from '../../workspace/workspace.service';
import { resolveRowPayload } from '../../shared/workspace-element-context';
import { AdminScreenContextService } from '../../admin/shared/admin-screen-context.service';
import * as _ from 'lodash-es';

import { safeJsonInput } from '../../shared/_utils/safe-json-input';
@Component({
    selector: 'gtw-user-audit',
    templateUrl: './user-audit.component.html',
    styleUrls: ['./user-audit.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class UserAuditComponent implements OnInit, OnDestroy {
  private readonly destroyRef = inject(DestroyRef);

  rowData: any = {};
  @Output() emitEvent = new EventEmitter<string>();

  private readonly subs = new Subscription();

  user_id = '';
  loading = false;
  showDisplayMsg = true;
  selectedAuditType = '';
  auditType = '';

  clients: any[] = [];
  selectedClient: any;
  client_key: any = 0;
  logged_in_user = '';
  taxYear = '';
  previewMode = 0;
  btnDisabled = 'Y';
  row_primary_key = 0;
  actionType = '';
  jurisdictionkey = 0;

  userAudit: any[] = [];
  userAuditMsg = false;
  moduleAudit: any[] = [];
  moduleAuditMsg = false;
  businessAudit: any[] = [];
  businessAuditMsg = false;

  bizzHierarchies: any[] = [];

  private onLoadModulesArray: any[] = [];
  private finalModulesArray: any[] = [];

  user_types = [
    { label: 'User', value: 1 },
    { label: 'Editor', value: 2 },
    { label: 'Admin', value: 3 },
    { label: 'Developer', value: 4 },
    { label: 'Super Admin', value: 5 },
  ];

  client_user_types = [
    { label: 'User', user_type_key: 1 },
    { label: 'Editor', user_type_key: 2 },
    { label: 'Admin', user_type_key: 3 },
    { label: 'Developer', user_type_key: 4 },
    { label: 'Super Admin', user_type_key: 5 },
  ];

  auditTypes = [
    { id: 1, name: 'Details', value: 'UPDATE_USER_DETAILS', arrayName: 'userAudit' },
    { id: 2, name: 'Modules', value: 'MODULE_ASSIGN', arrayName: 'moduleAudit' },
    { id: 3, name: 'Businesses', value: 'BUSINESS_ASSIGN', arrayName: 'businessAudit' },
  ];

  constructor(
    private appService: AppService,
    private userAdminService: UserAdminService,
    private alertService: GtwSnackbarService,
    private globalService: GlobalService,
    private gtwWorkspace: WorkspaceService,
    private adminScreenContext: AdminScreenContextService
  ) {}

  ngOnInit(): void {
    this.applyWorkspaceContext();
    this.subs.add(
      this.gtwWorkspace.setTabActive.subscribe(() => {
        this.applyWorkspaceContext();
        this.bootstrapFromRow();
      })
    );
    this.subs.add(
      this.globalService.globalParamsChanged$.subscribe(() => {
        this.applyWorkspaceContext();
        this.bootstrapFromRow();
      })
    );
    this.bootstrapFromRow();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private applyWorkspaceContext(): void {
    const raw = resolveRowPayload(this.adminScreenContext, this.gtwWorkspace);
    this.rowData = Array.isArray(raw)
      ? (raw[0] && typeof raw[0] === 'object' ? raw[0] : {})
      : (raw || {});
  }

  private bootstrapFromRow(): void {
    const nextId = this.rowData?.SSO_ID || this.rowData?.SSO || this.rowData?.user_id || this.rowData?.sso_id || '';
    if (!nextId) {
      return;
    }
    if (nextId === this.user_id) {
      return;
    }
    this.user_id = nextId;
    const userSettings = this.appService.USER_SETTINGS;
    const user = userSettings?.user;
    this.clients = user?.clients || [];
    this.selectedClient = _.find(this.clients, { client_key: user?.client?.client_key });
    this.client_key = this.selectedClient?.client_key || user?.client_key || 0;
    this.logged_in_user = user?.sso_id || '';
    this.taxYear = this.globalService.global?.globalParams?.tax_year || '';
    this.resetAuditView();
  }

  resetAuditView(): void {
    this.userAudit = [];
    this.moduleAudit = [];
    this.businessAudit = [];
    this.showDisplayMsg = true;
    this.selectedAuditType = '';
    this.auditType = '';
  }

  getAuditData(auditTypeJson: string): void {
    let auditData: any;
    try {
      auditData = safeJsonInput<any>(auditTypeJson, null, 'user-audit.parse1');
    } catch {
      return;
    }

    this.auditType = auditData.value;
    this.showDisplayMsg = false;
    this.loading = true;

    if (this.auditType === 'UPDATE_USER_DETAILS') {
      this.moduleAudit = [];
      this.businessAudit = [];
    } else if (this.auditType === 'MODULE_ASSIGN') {
      this.userAudit = [];
      this.businessAudit = [];
    } else {
      this.userAudit = [];
      this.moduleAudit = [];
    }

    const clientKey = this.selectedClient?.client_key || this.appService.USER_SETTINGS?.user?.client_key;

    this.userAdminService.getAuditData(auditData.value, this.user_id, clientKey).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        const data = response?.data || response;
        if (data?.callSuccess === '1') {
          if (data.jsonObj && data.jsonObj.length > 0) {
            if (auditData.name === 'Businesses') {
              const reqParams = safeJsonInput<any>(data.jsonObj[0].req_params, null, 'user-audit.parse2');
              this.loadBusinessAudit(data.jsonObj, reqParams.grp_obj_key, auditData.arrayName);
            } else if (auditData.name === 'Modules') {
              const reqParams = safeJsonInput<any>(data.jsonObj[0].req_params, null, 'user-audit.parse3');
              this.loadModuleAudit(data.jsonObj, reqParams[0]?.client_key || clientKey, auditData.arrayName);
            } else {
              this.loadDetailsAudit(data.jsonObj, auditData.arrayName);
            }
          } else {
            (this as any)[auditData.arrayName] = [];
            (this as any)[auditData.arrayName + 'Msg'] = true;
            this.loading = false;
          }
        } else {
          this.alertService.openSnackBar('Failed to fetch audit data', 'gtw-snackbar--red');
          this.loading = false;
        }
      },
      () => {
        this.loading = false;
        this.alertService.openSnackBar('Error fetching audit data', 'gtw-snackbar--red');
      }
    );
  }

  private loadDetailsAudit(hierarchyData: any[], arrayName: string): void {
    this.userAdminService.getUserClients({ user_id: this.user_id }).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        const data = response?.data || response;
        if (data?.clientResult && data?.error === '') {
          const clientList = data.clientResult;

          hierarchyData.forEach((row: any) => {
            const reqParams = safeJsonInput<any>(row.req_params, null, 'user-audit.parse4');
            row.dataRows = [reqParams];
            row.user_types = [...this.user_types];
            row.user_type = parseInt(reqParams.user_type, 10);
            row.active = parseInt(reqParams.active, 10);
            row.clientList = [];

            if (reqParams.clients && reqParams.clients.length > 0) {
              reqParams.clients.forEach((paramRow: any) => {
                const editedClient = _.find(clientList, { client_key: paramRow.client_key });
                if (editedClient) {
                  row.client_user_types = [...this.client_user_types];
                  row.clientList.push({ ...editedClient });
                }
              });
            }
            row.toggle = false;
          });

          (this as any)[arrayName] = hierarchyData;
          (this as any)[arrayName + 'Msg'] = hierarchyData.length === 0;
          this.loading = false;
        } else {
          this.alertService.openSnackBar('Problem getting clients.', 'gtw-snackbar--red');
          this.loading = false;
        }
      },
      () => {
        this.loading = false;
      }
    );
  }

  private loadModuleAudit(hierarchyData: any[], clientKey: any, arrayName: string): void {
    this.loading = true;
    const data: any = {
      client_key: clientKey,
      jurisdiction_key: this.jurisdictionkey || 1,
      user_id: this.user_id,
    };

    this.userAdminService.getUserAssign(data).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        const respData = response?.data || response;
        if (respData?.callSuccess === '1') {
          const userAssignNav = respData.jsonObject || [];
          this.mergeNonMatchedTaskHierarchy(userAssignNav);

          const dropdownOption = _.find(userAssignNav, { id: '5' });
          if (dropdownOption) {
            this.finalModulesArray = dropdownOption.children || [];
          } else if (userAssignNav.length > 0) {
            this.finalModulesArray = userAssignNav[0]?.children || [];
          }

          this.removeSelectedRoles(this.finalModulesArray);

          hierarchyData.forEach((row: any) => {
            const reqParams = safeJsonInput<any>(row.req_params, null, 'user-audit.parse5');
            row.dataRows = [reqParams];
            const tempModulesHierarchy = _.cloneDeep(this.finalModulesArray);
            this.setActivitiesSelected(tempModulesHierarchy, reqParams);
            row.modulesHierarchyList = tempModulesHierarchy;
            row.toggle = false;
          });

          (this as any)[arrayName] = hierarchyData;
          (this as any)[arrayName + 'Msg'] = hierarchyData.length === 0;
          this.onLoadModulesArray = _.cloneDeep(hierarchyData);
        } else {
          (this as any)[arrayName] = [];
          (this as any)[arrayName + 'Msg'] = true;
        }
        this.loading = false;
      },
      () => {
        this.loading = false;
      }
    );
  }

  private removeSelectedRoles(data: any[]): void {
    if (!data) return;
    data.forEach((channel: any) => {
      if (channel.role) {
        channel.role = {};
      }
      if (channel.children) {
        this.removeSelectedRoles(channel.children);
      }
    });
  }

  private setActivitiesSelected(data: any[], reqParams: any): void {
    if (!data || !reqParams) return;
    const paramsList = Array.isArray(reqParams) ? reqParams : [reqParams];
    data.forEach((row: any) => {
      paramsList.forEach((editedRow: any) => {
        if (_.find(paramsList, { jcd_ta_key: row.jcd_ta_key })) {
          if (row.roles && _.find(row.roles, { value: editedRow.jcd_ta_role_key })) {
            row.role = _.find(row.roles, { value: editedRow.jcd_ta_role_key });
          }
        }
      });
      if (row.children) {
        this.setActivitiesSelected(row.children, reqParams);
      }
    });
  }

  private mergeNonMatchedTaskHierarchy(jsonAry: any[]): void {
    for (let i = 0; i < jsonAry.length; i++) {
      const chlObj = jsonAry[i];
      if (chlObj.children && chlObj.children.length) {
        for (let c = 0; c < chlObj.children.length; c++) {
          const childTaskObj = chlObj.children[c];
          const childObjList = _.filter(chlObj.children, { parentTaskKey: childTaskObj.id });
          if (childObjList.length) {
            childTaskObj.processed = true;
            for (const childObj of childObjList) {
              if (childTaskObj.children) {
                childTaskObj.children.unshift(childObj);
              } else {
                childTaskObj.children = [childObj];
              }
            }
          }
        }
      }
      chlObj.children = _.filter(chlObj.children, { parentTaskKey: null });
    }
  }

  private loadBusinessAudit(hierarchyData: any[], argGroupObjKey: any, arrayName: string): void {
    const clientKey = this.selectedClient?.client_key || this.appService.USER_SETTINGS?.user?.client_key;

    const reqData: any = {
      taxyear: this.taxYear || this.globalService.global?.globalParams?.tax_year || '2020',
      sso_id: this.logged_in_user,
      userSsoId: this.user_id,
      grp_obj_key: argGroupObjKey,
      isBusHierAssign: 'Y',
      clientKey: clientKey,
    };

    this.previewMode = 0;
    this.bizzHierarchies = [];

    this.userAdminService.getBizzHierarchyBySsoByGroupObjKey(
      { admin: '' },
      this.convertToFormData(reqData)
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (data: any) => {
        if (data?.callSuccess === '1' && data.jsonObject?.length > 0) {
          this.setAllSelected(data.jsonObject, false);
          const record = { group_obj_key: argGroupObjKey, value: data.jsonObject, visible: true };
          this.bizzHierarchies = [record];

          hierarchyData.forEach((row: any) => {
            let reqParams: any;
            try {
              reqParams = safeJsonInput<any>(row.req_params, null, 'user-audit.parse6');
            } catch {
              reqParams = {};
            }

            if (!Array.isArray(reqParams)) {
              row.dataRows = [reqParams];
              const tempHierarchy = _.cloneDeep(this.bizzHierarchies);
              if (reqParams.jsonObj) {
                this.setBussSelected(tempHierarchy[0]?.value || [], reqParams.jsonObj);
              }
              row.businessHierarchyList = tempHierarchy;
            } else {
              row.dataRows = reqParams;
            }
            row.toggle = false;
          });

          (this as any)[arrayName] = hierarchyData;
          (this as any)[arrayName + 'Msg'] = hierarchyData.length === 0;
        } else {
          (this as any)[arrayName] = [];
          (this as any)[arrayName + 'Msg'] = true;
        }
        this.loading = false;
      },
      () => {
        this.loading = false;
      }
    );
  }

  private setAllSelected(items: any[], flag: boolean): void {
    if (!items) return;
    items.forEach((item: any) => {
      item.selected = flag;
      item.disableCheckbox = true;
      if (item.children) {
        this.setAllSelected(item.children, false);
      }
    });
  }

  private setBussSelected(items: any[], jsonObj: any[]): void {
    if (!items) return;
    items.forEach((row: any) => {
      if (_.find(jsonObj, { ME_KEY: row.mekey })) {
        row.selected = true;
      }
      if (row.children) {
        this.setBussSelected(row.children, jsonObj);
      }
    });
  }

  private convertToFormData(obj: any): FormData {
    const fd = new FormData();
    for (const key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] !== null && obj[key] !== undefined) {
        fd.append(key, obj[key]);
      }
    }
    return fd;
  }

  getUserTypeLabel(value: number): string {
    const found = _.find(this.user_types, { value });
    return found ? found.label : String(value);
  }

  compareClient(a: any, b: any): boolean {
    return a && b && a.client_key === b.client_key;
  }

  toggleRow(row: any): void {
    row.toggle = !row.toggle;
  }

  isAllExpanded(data: any[]): boolean {
    return data && data.some((node: any) => !node.collapsed);
  }

  toggleAll(data: any[]): void {
    if (!data) return;
    const expand = this.isAllExpanded(data);
    data.forEach((node: any) => {
      node.collapsed = expand;
    });
  }

  filterMenu(data: any[], searchTerm: string, arrayName: string, index: number): void {
    const matchName = (name: string) => {
      return (name || '').toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
    };
    const filter = (arr: any[]): any[] => {
      if (!Array.isArray(arr)) return [];
      return arr.filter((item: any) => {
        if (Array.isArray(item.children)) {
          item.children = filter(item.children);
        }
        return matchName(item.name) || (item.children && item.children.length);
      });
    };

    if (searchTerm && this.onLoadModulesArray[index]) {
      (this as any)[arrayName][index].modulesHierarchyList = filter(_.cloneDeep(this.onLoadModulesArray[index].modulesHierarchyList));
    } else if (this.onLoadModulesArray[index]) {
      (this as any)[arrayName][index].modulesHierarchyList = _.cloneDeep(this.onLoadModulesArray[index].modulesHierarchyList);
    }
  }
}
